/* eslint-disable no-param-reassign */

import * as types from './mutationTypes';

export default {
  [types.START_SEARCH_KEYWORDS](state, input) {
    state.isFetching = true;
    state.isFetched = false;
    state.fetchError = null;
    state.input = input;
    state.keywords = [];
  },

  [types.SET_SEARCH_KEYWORDS](state, payload) {
    state.isFetching = false;
    state.isFetched = true;
    state.fetchError = null;
    state.keywords = payload;
  },

  [types.SEARCH_KEYWORDS_ERROR](state, error) {
    state.isFetching = false;
    state.isFetched = false;
    state.fetchError = error;
  },

  [types.CHANGE_INPUT](state, input) {
    state.input = input;
  },

  [types.ADD_KEYWORD](state, keyword) {
    state.input = '';
    state.keywords = [];
    state.selectedKeywords.push(`{"suggestionWord":"${keyword.suggestionWord}","type":"${keyword.type}","value":"${keyword.value}","ics":"${keyword.ics}"}`);
  },

  [types.REMOVE_KEYWORD](state, keyword) {
    state.selectedKeywords = state.selectedKeywords.filter(f => f !== keyword);
  },

  [types.SET_KEYWORDS](state, keywords) {
    state.selectedKeywords = keywords;
  },

  [types.UNSET_KEYWORDS](state) {
    state.selectedKeywords = [];
  },
};
